import { defineStore } from "pinia";
import { AxiosClient } from "@/axios/axios";

export const useAppStore = defineStore("appStore", {
  state: () => ({
    error: null,
    isLoading: false,
    isSaving: false,
    logo: null,
    name: null,
    info: {},
  }),
  actions: {
    getAppInfo() {
      this.isLoading = true;
      return new Promise((resolve, reject) => {
        AxiosClient.get(`info`)
          .then((response) => {
            this.isLoading = false;
            this.info = response?.data?.data ?? {}
            this.logo = response?.data?.data?.Logo
            this.name = response?.data?.data?.Name
            resolve(response.data);
          })
          .catch((error) => {
            this.error = error.response?.data?.message;
            this.isLoading = false;
            reject(error);
          });
      });
    },
    getCreate(params) {
      return new Promise((resolve, reject) => {
        this.isLoading = true;
        AxiosClient.get(`v1/qsqw/${params}`)
          .then((response) => {
            this.isLoading = false;
            resolve(response.data);
          })
          .catch((error) => {
            this.error = error.response?.data?.message;
            if (error.status === 422) {
              this.errors = error.response.data.errors;
            }
            this.isLoading = false;
            reject(error);
          });
      });
    },
    create(params, payload) {
      return new Promise((resolve, reject) => {
        this.isSaving = true;
        AxiosClient.post(`v1/qsqw/${params}`, payload, {
            headers: {
            "Content-Type": "multipart/form-data",
          },
        })
          .then((response) => {
            this.isSaving = false;
            resolve(response.data);
          })
          .catch((error) => {
            this.error = error.response?.data?.message;
            if (error.status === 422) {
              this.errors = error.response.data.errors;
            }
            this.isSaving = false;
            reject(error);
          });
      });
    },
  },
});
